import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { cars } from "../mock";
import CarCard from "./CarCard";
import { Button } from "./ui/button";

export default function FeaturedCars() {
  const featured = [...cars].sort((a, b) => a.price - b.price).slice(0, 4);

  return (
    <section id="auto" className="py-20 bg-[#f5f6f8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10">
          <div className="max-w-2xl">
            <span className="text-[#e2001a] font-semibold text-sm uppercase tracking-wide">Vetrina auto</span>
            <h2 className="font-display font-extrabold text-3xl sm:text-4xl text-[#16181d] mt-2">
              Le nostre auto in vendita
            </h2>
            <p className="text-gray-500 mt-3">
              Auto usate selezionate e controllate dalla nostra officina. Tagliandate e garantite.
            </p>
          </div>
          <Link to="/auto">
            <Button variant="outline" className="rounded-full border-[#16181d] text-[#16181d] hover:bg-[#16181d] hover:text-white">
              Vedi tutte le auto <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {featured.map((car) => (
            <CarCard key={car.id} car={car} />
          ))}
        </div>
      </div>
    </section>
  );
}
